import { ActivityType } from 'interfaces/common.interface';
import { getAppState } from 'store/store-access';

export const findCustomRoutinePosition = (
  activity: ActivityType
): number | undefined => {
  const custom_routines = getAppState()?.setting.currentSettings.custom_routines;
  if (!custom_routines) {
    return undefined;
  }

  return custom_routines.findIndex((routine) =>
    routine.standalone_activities?.some((a) => a.id === activity.id)
  );
};
